import { POST } from "../../APiHelper/API";

export const addTeamToLeagueAPI = (league_id, participant_id, wy_id, legacy_participant_id, onSuccess, onError) => {
    const data = {
        participant_id: participant_id,
        wy_id: wy_id,
        legacy_participant_id: legacy_participant_id
    }
    POST(`/api/v1/leagues/${league_id}/add_team`, data, onSuccess, onError)
}